"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRequest = void 0;
var _ahooks = require("ahooks");
var _ = require("./");
var _lodash = require("lodash");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var getRequestConfigObjectFromConfig = function getRequestConfigObjectFromConfig(config) {
  return (0, _lodash.isString)(config) ? {
    url: config
  } : config;
};
var requestService = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(args, config,
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  formatResult) {
    var serviceConfig, handleErrors, withErrorsHandler, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // We can't supply string or object as a 'service' in v3, backfilling it
            // to support all request config formats currently used in the apps
            serviceConfig = (0, _lodash.isFunction)(config) ? getRequestConfigObjectFromConfig(config.apply(void 0, _toConsumableArray(args))) : getRequestConfigObjectFromConfig(config);
            handleErrors = false;
            withErrorsHandler = serviceConfig.withErrorsHandler;
            handleErrors = (0, _lodash.isUndefined)(withErrorsHandler) ? true : withErrorsHandler;
            delete serviceConfig.withErrorsHandler;

            // as AxiosRequestConfig
            if (!handleErrors) {
              _context.next = 11;
              break;
            }
            _context.next = 8;
            return (0, _.api)(serviceConfig);
          case 8:
            _context.t0 = _context.sent;
            _context.next = 14;
            break;
          case 11:
            _context.next = 13;
            return (0, _.apiWithoutErrorsHandler)(serviceConfig);
          case 13:
            _context.t0 = _context.sent;
          case 14:
            result = _context.t0;
            return _context.abrupt("return", (0, _lodash.isFunction)(formatResult) ? formatResult(result.data) : result.data);
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function requestService(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
var useRequest = function useRequest(config) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var formatResult = options.formatResult;
  if (formatResult) {
    delete options.formatResult;
  }
  return (0, _ahooks.useRequest)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return requestService(args, config, formatResult);
  }, options);
};
exports.useRequest = useRequest;